var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7656 7.28516C14.2891 3.92188 11.3359 1.625 8 1.625C4.63672 1.625 1.68359 3.92188 0.207031 7.28516C0.152344 7.42188 0.125 7.61328 0.125 7.75C0.125 7.88672 0.152344 8.10547 0.207031 8.24219C1.68359 11.6055 4.63672 13.875 8 13.875C11.3359 13.875 14.2891 11.6055 15.7656 8.24219C15.8203 8.10547 15.875 7.88672 15.875 7.75C15.875 7.61328 15.8203 7.42188 15.7656 7.28516ZM11.9375 7.75C11.9375 9.9375 10.1602 11.6875 8 11.6875C5.8125 11.6875 4.0625 9.9375 4.0625 7.75C4.0625 5.58984 5.8125 3.8125 8 3.8125C10.1602 3.8125 11.9375 5.58984 11.9375 7.75ZM8 5.125C7.91797 5.125 7.83594 5.15234 7.75391 5.15234C7.89062 5.39844 8 5.69922 8 6C8 6.98438 7.20703 7.75 6.25 7.75C5.92188 7.75 5.62109 7.66797 5.375 7.53125C5.375 7.61328 5.375 7.69531 5.375 7.75C5.375 9.19922 6.55078 10.375 8 10.375C9.44922 10.375 10.625 9.22656 10.625 7.77734C10.625 6.32812 9.42188 5.125 8 5.125Z",
    fill: "#0F031E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ad13701bda56cb3ecb8fe42b559019c9.svg";
export { ForwardRef as ReactComponent };